import { useEffect, useState } from 'react';

import { TextInputProps } from './text-input.component';

interface ViewProps {
    valid: boolean;
    touched: boolean;
    changeTouched: React.Dispatch<React.SetStateAction<boolean>>;
    isValid: () => boolean;
    onBlur: () => void;
}

const useTextInput = (props: TextInputProps): ViewProps => {
    const [touched, changeTouched] = useState<boolean>(false);
    const [valid, changeValid] = useState<boolean>(false);

    const isValid = (): boolean => {
        let check = true;
        if (check === true && props.required === true && (props.value === '' || props.value === undefined)) check = false;
        if (props.valid !== undefined && check === true) check = props.valid;
        changeValid(check);
        return check;
    };

    useEffect(() => {
        if (props.isValidCallback) {
            props.isValidCallback(isValid());
        } else isValid();
    }, [props.value, props.valid, touched]);

    useEffect(() => {
        if (props.submitted) {
            !touched && changeTouched(true);
        }
    }, [props.submitted]);

    const onBlur = () => {
        if (touched && (props.value === '' || !props.value)) {
            changeValid(true);
            changeTouched(false);
        }
    };
    return {
        valid,
        touched,
        isValid,
        changeTouched,
        onBlur
    };
};

export default useTextInput;
